import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import enTranslation from "./locale/en/translation.json";
import jaTranslation from "./locale/ja/translation.json";

const resources = {
  en: { translation: enTranslation },
  ja: { translation: jaTranslation },
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: localStorage.getItem("language") || "en", // Default language
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
